<script>
  import {onMount, onDestroy} from 'svelte';

  export let id = 'richTextEditor';
  export let value = '<p>this is a test</p>';

  let quill = null;

  $: if (value){
    const editor = document.getElementById(id);
    if(editor){
      document.getElementById(id).getElementsByClassName('ql-editor')[0].innerHTML = value;
      document.getElementById(id).getElementsByClassName('ql-editor')[0].classList.remove('ql-blank');
    }
  } else {
    const editor = document.getElementById(id);
    if(editor){
      document.getElementById(id).getElementsByClassName('ql-editor')[0].innerHTML = '';
    }
  }

  onMount(() => {
    quill = new Quill(`#${id}`, {
      theme: 'bubble',
      modules: {
        toolbar: false
      }
    });

    delete quill.getModule('keyboard').bindings["9"];

    document.getElementById(id).getElementsByClassName('ql-editor')[0].addEventListener('blur', function(event){
      value = document.getElementById(id).getElementsByClassName('ql-editor')[0].innerHTML;      
    });

    document.getElementById(id).getElementsByClassName('ql-editor')[0].innerHTML = value;
    document.getElementById(id).getElementsByClassName('ql-editor')[0].classList.remove('ql-blank');
    
  });

  onDestroy(() => {
    quill = null;
  })

  function handleOnBlur(event) {
    value = document.getElementById(id).getElementsByClassName('ql-editor')[0].innerHTML;
  }
</script>

<div class="rich-text-editor" id={id} on:blur={handleOnBlur}>
  
</div>

<style>
.rich-text-editor {
  border: 1px solid #DDDDDD;
}

:global(.rich-text-editor.ql-container) {font-size: 1rem;}

:global(.ql-editor) {min-height: 50px; color: #495057; background-color: white;}
</style>